<template>
  <outside-click-listener class="relative" @clickoutside="isOpened = false">
    <search-form-input
      :label="label"
      :name="name"
      :value="isOpened ? userInput : value"
      @input="handleInput"
      :isOpened="isOpened"
      @openstatechange="handleOpenStateChange"
      class="cursor-text"
    />

    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-1/2 -translate-y-1/2 right-4 lg:right-6 pointer-events-none">
    	<path d="M7.25 9.375L12.5 14.625L17.75 9.375" stroke="currentcolor" stroke-width="1.5"/>
    </svg>

    <close-button v-if="value.length" @click="handleClearClick" />

    <div
      class="search-form-dropdown font-[500] px-4 lg:px-2 2xl:px-4 py-2"
      v-show="isOpened"
      style="display: none"
      :class="{ 'lg:w-[30rem_!important]': slicedResults.length }"
    >
      <p v-if="isLoading" class="px-4 py-2 custom-label-tighter opacity-40" v-text="t.loading"></p>
      <ul v-else-if="slicedResults.length">
        <li
          v-for="item in slicedResults"
          :key="generateKey(item)"
          class="
            custom-choice-option
            justify-between
            cursor-pointer
          "
          @click="handleItemClick(item)"
        >
          <span v-text="item.name"></span>
          <span
            v-text="item.code"
            class="opacity-40 custom-label-tighter"
          ></span>
        </li>
      </ul>
      <p v-else-if="userInput" class="px-4 py-2 custom-label-tighter opacity-40" v-text="t.noResultsFound"></p>
      <p v-else class="px-4 py-2 custom-label-tighter opacity-40" v-text="t.startTyping"></p>
    </div>
  </outside-click-listener>
</template>

<script>
import debounce from 'lodash/debounce'

import SearchFormInput from './input.vue'
import CloseButton from './close-button.vue'
import OutsideClickListener from '../outside-click-listener.vue'

export default {
  components: { SearchFormInput, CloseButton, OutsideClickListener },
  props: {
    name: String,
    label: String,
    url: String,
    value: String,
  },
  data() {
    return {
      results: [],
      userInput: '',
      isOpened: false,
      isLoading: false,
      ignoreNextInputChange: false,
      isOpened: false,
      t: window.bcimmoTranslations || {},
    }
  },
  methods: {
    handleOpenStateChange(isOpened) {
      this.isOpened = isOpened
    },
    generateKey(item) {
      return `${item.name}${item.code}`
    },
    handleItemClick(item) {
      this.ignoreNextInputChange = true
      this.$emit('input', item.name)
      this.$emit('optionselected', item)
      this.isOpened = false
    },
    handleInput(text) {
      this.userInput = text 
    },
    handleClearClick() {
      this.ignoreNextInputChange = true
      this.$emit('input', '')
      this.$emit('optionselected', null)
    }
  },
  watch: {
    trimmedInput: debounce(function () {
      if (this.ignoreNextInputChange) {
        this.ignoreNextInputChange = false
        return
      }

      if (this.trimmedInput === '') {
        this.results = []
        return
      }

      this.isLoading = true
      fetch(`${this.url}/${this.trimmedInput}`)
        .then((res) => res.json())
        .then((json) => {
          this.results = json
          this.isOpened = true
          this.isLoading = false
        })
    }, 500),
  },
  computed: {
    trimmedInput() {
      return this.userInput.trim()
    },
    slicedResults() {
      return this.results.slice(0, 10)
    },
  },
}
</script>
